export function fontFamily(
  font: string,
  fallback = 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif'
) {
  return `"${font}", ${fallback}`;
}
